import { ApplicationToComponentCardStrategy }
  from '~/modules/Products/Infrastructure/ApplicationToComponentStrategies/ApplicationToComponentCardStrategy'
import { ComponentTrophyDtoTransformer } from '~/modules/Products/Infrastructure/ComponentTrophyDtoTransformer'
import { ApplicationProductDto } from '~/modules/Products/Application/ApplicationProductDto'
import { ApplicationTrophyDto } from '~/modules/Products/Application/Dtos/ApplicationTrophyDto'
import { ComponentProductDto } from '~/modules/Products/Infrastructure/Dtos/ComponentProductDto'

export class ApplicationToComponentTrophyStrategy implements ApplicationToComponentCardStrategy {
  doesFit (product: ApplicationProductDto): boolean {
    return product.type === 'trophy'
  }

  toComponentDto (product: ApplicationProductDto): ComponentProductDto {
    return ComponentTrophyDtoTransformer.fromApplication(product as ApplicationTrophyDto)
  }
}
